import { Outlet } from '@tanstack/react-router';
import { useStravaStatus } from '../api/queries';
import type { SessionUser } from '../auth/session';
import { UploadQueueProvider } from '../features/upload/UploadQueueProvider';
import { PhoneTabBar } from '../ui/PhoneTabBar';
import { AppBar } from './AppBar';
import styles from './app.module.css';

export function AppLayout({ user }: { user: SessionUser }) {
  const strava = useStravaStatus();
  return (
    <UploadQueueProvider>
      <div className={styles.shell}>
        <AppBar user={user} strava={strava.data} />
        <main className={styles.main}><Outlet /></main>
        <PhoneTabBar />
      </div>
    </UploadQueueProvider>
  );
}
